
import { Options, mixins } from "vue-class-component";
import { NavListState } from '@/constant/computerType'
import { JumpLink } from '@/mixins/JumpLink'
import { store } from '@/store'
import Cookies from 'js-cookie'
import { ktpUrl } from '@/constant/options'
import { PortalMutationTypes } from '@/store/modules/portal/mutation-types'

@Options({
  name: 'PortalHeader',
  props: {
    headerData: {
      type: Object,
      default: () => ({})
    }
  }
})
export default class PortalHeader extends mixins(JumpLink) {
  search = ''
  // currentId: number = -1;
  readonly headerData!: any;

  get isMobile() {
    return store.state.portal.isMobile
  }
  // 显示 搜索框
  private showInputBox: boolean = true;

  get currentId() {
    return store.state.portal.portalCurrentPageId;
  }

  get userAvatar() {
    return store.state.portal.portalInfo.avatar;
  }

  get portalToken() {
    return store.state.portal.portalToken;
  }

  mounted() {
    if(this.isMobile) {
      this.showInputBox = false
    }
  }

  // 点击放大镜搜索课程
  clickMagnifier() {
    if(this.isMobile && this.showInputBox || !this.isMobile) {
      this.searchCourseName();

      if(this.isMobile) {
        this.showInputBox = false;
      }
    } else if(this.isMobile && !this.showInputBox) {
      this.showInputBox = true;
      const input = this.$refs['magnifier'] as HTMLInputElement;
      input.focus();
    }
  }

  blurMagnifier() {
    if(this.isMobile) {
      this.showInputBox = false;
    }
  }

  // 去主页
  goMainPage() {
    open('/#/portalPage/Home?id=' + this.headerData.microid, '_self')
  }

  // 搜索课程名称
  searchCourseName() {
    const route = this.$route
    this.$router.push({
      path: '/portalPage/CoursePlaza',
      query: {
        ...route.query,
        search: this.search,
        t: Date.now()
      }
    })
  }

  // 点击菜单
  clickMenu(item: NavListState, index: number) {
    if (item.link_type === 'micro' || item.link_type === 'course' || (item.link_url && item.link_target === '_self')) {
      // this.currentId = index
      store.commit(PortalMutationTypes.SET_PORTAL_CURRENT_PAGE_ID, index)
    }
    this.jumpLink(item);
  }

  goKeTangPai(address: 'login' | 'regist' | 'register') {
    if(this.isMobile && address === 'regist') {
      address = 'register'
    }
    open(ktpUrl + address + '?from=' + encodeURIComponent(location.href));
  }

  // 移除portal-token
  removePortalToken() {
    Cookies.remove('portal-token');
    store.commit(PortalMutationTypes.SET_PORTAL_TOKEN, '')
  }
}
